import { useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "../../components/ui/tooltip";

const TruncatedCell = ({ children }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span ref={textRef} className="block truncate cursor-default">
            {children}
          </span>
        </TooltipTrigger>
        {isTruncated && (
          <TooltipContent className=" break-words" side="bottom" align="center">
            {children}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

export default TruncatedCell;
